import { USER_SIGNUP_ERROR } from '../actions/SignUp';
import { USER_SIGNED_UP_EMAIL_RESENT_ERROR } from '../actions/ResendSignUpEmail';
import { PRODUCT_PUBLISHED_ERROR, PRODUCT_PUBLISHED } from '../actions/product-management/PublishProduct';

const initialState = {
  message: '',
  userSignup: {},
  publishProduct: {},
  resendSignUpEmail: {},
};

const formErrors = (state = initialState, action) => {
  switch (action.type) {
    case USER_SIGNUP_ERROR:
      return Object.assign({}, state, {
        userSignup: action.errors,
      });
    case PRODUCT_PUBLISHED_ERROR:
      return Object.assign({}, state, {
        publishProduct: action.errors,
        message: action.message,
      });
    case PRODUCT_PUBLISHED:
      // Clear errors on product published success
      return Object.assign({}, state, {
        publishProduct: {},
        message: '',
      });
    case USER_SIGNED_UP_EMAIL_RESENT_ERROR:
      return Object.assign({}, state, {
        resendSignUpEmail: action.errors,
      });
  }

  return state;
};

export default formErrors;
